import { Controller } from "@hotwired/stimulus"
import { Html5Qrcode } from "html5-qrcode"

export default class extends Controller {
  static targets = ["output", "scanner"]
  static values = {
    errorMessage: { type: String, default: "Camera access error" }
  }
  
  connect() {
    this.html5QrCode = null
    this.isScanning = false
    this.hideScanner()
    
    // Create a container for error messages
    this.errorContainer = document.createElement('div')
    this.errorContainer.className = 'alert alert-danger mt-2 d-none'
    this.scannerTarget.parentNode.insertBefore(this.errorContainer, this.scannerTarget.nextSibling)
  }

  hideScanner() {
    this.scannerTarget.parentNode.classList.add('d-none')
  }

  showScanner() {
    this.scannerTarget.parentNode.classList.remove('d-none')
  }
  
  async startScanning() {
    if (this.isScanning) return
    
    try {
      // Hide any previous error messages
      this.errorContainer.classList.add('d-none')
      
      // Check if camera permissions are available
      const stream = await navigator.mediaDevices.getUserMedia({ video: true })
      // Stop the stream immediately after checking permissions
      stream.getTracks().forEach(track => track.stop())

      // show scanner
      this.showScanner()
      
      this.isScanning = true
      this.html5QrCode = new Html5Qrcode(this.scannerTarget.id)
      
      const config = { fps: 10, qrbox: { width: 250, height: 250 } }
      
      await this.html5QrCode.start(
        { facingMode: "environment" },
        config,
        this.onScanSuccess.bind(this),
        this.onScanFailure.bind(this)
      )
    } catch (error) {
      this.handleCameraError(error)
    }
  }
  
  handleCameraError(error) {
    console.error("Camera error:", error)
    
    let errorMessage = this.errorMessageValue
    
    if (error.name === 'NotAllowedError') {
      errorMessage = "Camera access denied. Please allow camera access in your browser settings."
    } else if (error.name === 'NotReadableError') {
      errorMessage = "Cannot access camera. It may be in use by another application or there's a hardware issue."
    } else if (error.name === 'NotFoundError') {
      errorMessage = "No camera found on this device."
    } else if (error.name === 'OverconstrainedError') {
      errorMessage = "Camera does not satisfy the requested constraints."
    }
    
    // Display the error message
    this.errorContainer.textContent = errorMessage
    this.errorContainer.classList.remove('d-none')
    
    // Dispatch an error event
    const event = new CustomEvent('qrcode:error', { 
      detail: { error: error },
      bubbles: true
    })
    this.element.dispatchEvent(event)
  }
  
  stopScanning() {
    if (!this.isScanning || !this.html5QrCode) return
    
    this.html5QrCode.stop().then(() => {
      this.hideScanner()
      this.isScanning = false
      this.html5QrCode = null
    }).catch(error => {
      console.error("Error stopping QR code scanner:", error)
    })
  }
  
  onScanSuccess(decodedText, decodedResult) {
    if (this.hasOutputTarget) {
      this.outputTarget.value = decodedText
      this.outputTarget.dispatchEvent(new Event('change'))
    }

    // Check vehicle exists
    this.checkVehicleExists(decodedText)
    
    // Optionally stop scanning after successful scan
    // this.stopScanning()
    
    // You can also dispatch a custom event with the scanned result
    const event = new CustomEvent('qrcode:scanned', { 
      detail: { text: decodedText, result: decodedResult },
      bubbles: true
    })
    this.element.dispatchEvent(event)
  }
  
  onScanFailure(error) {
    // Handle scan failures (optional)
    // console.error(`QR Code scanning failed: ${error}`)
  }
  
  disconnect() {
    this.stopScanning()
  }

  checkVehicleExists(sqid) {
    try {
      console.log(sqid)
      fetch(`/vehicles/${sqid}/exists`)
        .then(response => response.json())
        .then(data => {
          if (data.exists) {
            window.location.href = `/vehicles/${sqid}`
          }
        })
        .catch(error => {
          console.error('Error searching vehicle by sqid:', error)
        })
    } catch (error) {
      console.error('Error searching vehicle by sqid:', error)
    }
  }
}
